import type { Directive } from 'vue'
import { initializePreline } from '@/utils/preline-manager'

export const prelineDirective: Directive = {
  mounted(_el: HTMLElement) {
    // Initialize Preline components for this element
    initializePreline()
  },
  updated(_el: HTMLElement) {
    // Reinitialize Preline components when element is updated
    initializePreline()
  }
} 